
import MaterialTable from 'material-table';
import { defaultGridOptions, tooltipDelay, useGridColDefs } from '../../utils/GridUtils';
import { Button, makeStyles, Tooltip } from '@material-ui/core';
import { centeredCell } from '../../constants/StyleConstants';
import AnimatedButton from '../../components/UI/AnimatedButton';
import { useContext, useEffect, useState } from 'react';
import { LoginContext } from '../../contexts/LoginContext';
import FormatListNumberedOutlinedIcon from '@material-ui/icons/FormatListNumberedOutlined';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { Fragment } from 'react';
import LogisticsConfirmationModal from '../Logistics/LogisticsConfirmationModal';
import PersonIcon from "@mui/icons-material/Person";
import CertificateExclusionSupplierDialog from '../MaterialsRequires/QualityCertificateExclusion/CertificateExclusionSupplierDialog';

import ActivityLogs from "../MaterialsRequires/MaterialActivityLogs/ActivityLogsDialog";
import { SOURCETYPES } from "../../constants/GlobalConstants";

const useStyles = makeStyles(theme => ({
  centeredCell,
  root: {
    marginTop: '3em',
  },
  gridActions: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: '1em',
  },
  gridControls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  gridButtonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '1em',
  },
  gridReference: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    columnGap: '1em',
    fontSize: '.8em',
  },
  reference: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  leftSideButton: {
    borderRadius: '1em',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  rightSideButton: {
    borderRadius: '1em',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  activeGlow: {
    color: 'rgb(0, 255, 0)',
    boxShadow: '0px 0px 10px 0px rgb(0, 255, 0, .5)',
    borderRadius: '50%',
    margin: 0,
    stroke: 'rgb(0, 255, 0, .5)',
    strokeWidth: 4,
    strokeOpacity: 0.7,
  },
  hasNoComments: {
    color: '#BDBDBD',
  },
  sortButton: {
    '&.MuiButton-root': {
      minWidth: 'unset',
    },
    '&.MuiButton-startIcon': {
      margin: 0,
    },
  },
}));

const GridActions = ({
  setOpen,
  rows,
  openExclusion,
  setOpenExclusion,
  ...restProps
}) => {
  const classes = useStyles();


return  (
  <div className={classes.gridControls}>
      <div className={classes.gridButtonsWrapper}>

        <CertificateExclusionSupplierDialog setOpen={setOpenExclusion} open={openExclusion} />
        <Button
          variant="contained"
          color="primary"
          size="small"
          //className={classes.actionHeaderButton}
          startIcon={<PersonIcon />}
          onClick={() => setOpenExclusion(true)}
        >
          Excluir proveedor
        </Button>
       
      </div>
    </div>
  );
};

const ExcludedSuppliersGrid = ({
  data,
  loading,
  tableRef,

  openExclusion,
  setOpenExclusion,

  openActivity,
  setOpenActivity,

  open,
  setOpen,
  gridActions,
}) => {
  const classes = useStyles();

  const BoldValue = ({ value }) => {
    return (<b>{value}</b>);
  };
  
  const colDefs = useGridColDefs([
    { title: 'Cuit Proveedor', field: 'supplierCuit'},
    { title: 'Nombre Proveedor', field: 'supplierName'},
    { title: 'Fecha Inicio Exclusión', field: 'startDate', valueType: 'date'},
    { title: 'Fecha Fin Exclusión', field: 'endDate', valueType: 'date'} 

  ]);

  return (
    <Fragment>

      <div className={classes.root}>
        <div className={classes.gridActions}>
          <GridActions  loading={loading} setOpen={setOpen} rows={data} openExclusion={openExclusion} setOpenExclusion={setOpenExclusion}{...gridActions} />
        </div>
        <MaterialTable
          {...defaultGridOptions}
          options={{
            ...defaultGridOptions.options,
            pageSizeOptions: [...defaultGridOptions.options.pageSizeOptions, defaultGridOptions.options.pageSizeOptions.last() * 2],
            selection: false,
            headerSelectionProps: { color: 'primary'}, 
            selectionProps: rowData => {
              return {
                color: 'primary',
              };
            },
          }}
          //onSelectionChange={(rows, row) => setSelectedRows(rows)}
          columns={colDefs}
          data={data}
          isLoading={loading}
          tableRef={tableRef}
        />
      </div>
      <Button
        variant="contained"
        color="primary"
        style={{ marginTop: "10px" }}
        size="small"
        onClick={() => setOpenActivity(true)}
        startIcon={<ListAltIcon />}
      >
        Registro de actividades
      </Button>
      <ActivityLogs open={openActivity} setOpen={setOpenActivity} sourceType={SOURCETYPES.EXCLUDED_SUPPLIER}/>
    </Fragment>
  );
};

export default ExcludedSuppliersGrid;